<template>
  <div class="article-detail">
    <h4 class="title">{{ articleDetail.title }}</h4>
    <div class="publish-wrapper">
      <img class="publish-img" src="~@/assets/image/hcfm_logo.png" alt="" />
      <div class="publish-content">
        <span>{{ articleDetail.publishName }}</span>
        <span>{{ articleDetail.createTime }}</span>
      </div>
    </div>
    <div class="intro" v-if="articleDetail.absTract">
      <di v-html="articleDetail.absTract"></di>
    </div>
    <div
      id="content"
      class="content"
      v-html="articleDetail.content"
      @click="handleClickContent"
    ></div>
    <div class="info-name">{{ articleDetail.editorName }}</div>
    <div class="info-name">{{ articleDetail.reporterName }}</div>
    <div class="info-name">{{ articleDetail.messenger }}</div>
    <div class="info-name">{{ articleDetail.from }}</div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { getHcfmArticle } from "@/http/api";

export default {
  name: "HcfmArticle",
  data() {
    return {
      imgList: [],
      operateId: null,
      articleDetail: {},
    };
  },
  mounted() {
    this.init();
  },
  updated() {
    let obj = document.getElementById("content");
    let imgs = obj.getElementsByTagName("img");
    if (imgs.length > 0) {
      this.imgList = [];
      for (let i = 0; i < imgs.length; i++) {
        this.imgList.push(imgs[i].src);
      }
    }
  },
  methods: {
    init() {
      console.log(this.$route.path);
      let path = this.$route.path;
      let pathArr = path.split("/");
      this.operateId = pathArr[pathArr.length - 1];
      this.getArticleDetail();
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = require("@/assets/image/hcfm_logo.png");
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    async getArticleDetail() {
      const { data } = await getHcfmArticle(this.operateId);
      data.absTract = data.absTract ? data.absTract.trim() : null;
      this.articleDetail = data;
      document.title = this.articleDetail.title
        ? this.articleDetail.title
        : "花城+";
    },
    handleClickContent(e) {
      if (e.target.nodeName === "IMG") {
        let handleImgIndex = this.imgList.findIndex((value) => {
          return value === e.target.src;
        });
        ImagePreview({
          images: this.imgList,
          startPosition: handleImgIndex,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.article-detail {
  position: relative;
  box-sizing: border-box;
  padding: 0 15px;
  margin-top: 10px;
  width: 100%;
  overflow: hidden !important;
  font-size: 18px;
  font-family:FZBiaoYaSong-GBK_YS!important;

  .title {
    font-size: 1.35rem;
    font-weight: 600;
    line-height: 1.65;
    text-align: left;
    font-family: Microsoft YaHei!important;
  }

  .publish-wrapper {
    display: flex;
    height: 42px;
    margin-top: 15px;

    .publish-img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }

    .publish-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      font-size: 14px;
      box-sizing: border-box;
      padding: 2px 0;
    }
  }

  .intro {
    position: relative;
    background: #f9f9f9;
    font-size: 14px;
    padding: 15px;
    margin: 10px 0;
    border-radius: 4px;
    color: #bbb;
    box-sizing: border-box;

    &::before {
      position: absolute;
      content: "“";
      top: 0;
      left: 0;
      transform: translate(-30%, -20%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }

    &::after {
      position: absolute;
      content: "”";
      bottom: 0;
      right: 0;
      transform: translate(30%, 75%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }
  }

  .content {
    overflow-x: hidden;
    margin-top: 10px;
    width: 100%;
  }

  .content p {
    line-height: 1.75;
    margin: 0;
    padding-bottom: 1em;
  }

  .info-name {
    margin-top: 5px;

    &:last-child {
      margin-bottom: 20px;
    }
  }

  .thumbs-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 20px;
    bottom: 50px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 1px 3px 6px #bbb;
    color: #fff;
    font-size: 34px;
    z-index: 9999;
    cursor: pointer;

    .praise-num {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(25%, -25%);
      /* background: rgba(231, 56, 40, 0.6); */
      background: #bbb;
      padding: 0 8px;
      height: 20px;
      border-radius: 10px;
      font-size: 12px;
      color: #fff;
    }
  }

  @media screen and (min-width: 768px) {
    .thumbs-wrapper {
      left: 50%;
      transform: translateX(290px);
    }
  }
}
</style>
